import { IOpenClose } from '@interfaces/common';

export interface INotificationModalData {
  itemId: string | number;
  type: TSupplementType;
}

export interface INotificationModalProps extends IOpenClose {
  dataInModal: INotificationModalData | null;
  isMedicationMode?: boolean;
  onConfirm: (data: INotificationModalData) => void;
  onExited: () => void;
}

export enum TSupplementType {
  INQUIRY,
  INQUIRY_ITEM,
}
